export const DEFAULT_APPOINTMENT_TYPE_COLOR = '#1976D2';

export const APPOINTMENT_TYPE_COLOR_PRESETS = [
  '#1976D2',
  '#00897B',
  '#43A047',
  '#F9A825',
  '#FB8C00',
  '#E53935',
  '#8E24AA',
  '#5E35B1',
] as const;

const HEX6_RE = /^#([0-9A-Fa-f]{6})$/;
const HEX3_RE = /^#([0-9A-Fa-f]{3})$/;

/** Normalize #RGB / #RRGGBB to #RRGGBB uppercase. Returns null if invalid. */
export const normalizeAppointmentTypeColor = (raw: string): string | null => {
  const trimmed = raw.trim();
  const hex6 = HEX6_RE.exec(trimmed);
  if (hex6) return `#${hex6[1].toUpperCase()}`;
  const hex3 = HEX3_RE.exec(trimmed);
  if (!hex3) return null;
  const [r, g, b] = hex3[1];
  return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
};

export const isAppointmentTypeColorPreset = (color: string): boolean => {
  const normalized = normalizeAppointmentTypeColor(color);
  if (!normalized) return false;
  return (APPOINTMENT_TYPE_COLOR_PRESETS as readonly string[]).some(
    (preset) => preset.toUpperCase() === normalized,
  );
};

/** Khi sửa loại có màu tùy chỉnh cũ — hiển thị và lưu một trong các preset. */
export const coerceAppointmentTypeColorToPreset = (raw: string | null | undefined): string => {
  const normalized = normalizeAppointmentTypeColor(raw || '');
  if (normalized && isAppointmentTypeColorPreset(normalized)) {
    const match = APPOINTMENT_TYPE_COLOR_PRESETS.find(
      (preset) => preset.toUpperCase() === normalized,
    );
    return match ?? DEFAULT_APPOINTMENT_TYPE_COLOR;
  }
  return DEFAULT_APPOINTMENT_TYPE_COLOR;
};
